import { lazy, Suspense } from 'react'
import { Link, type RouteObject } from 'react-router'
import { Cargando } from '@/componentes/Cargando'
import { ErrorDeRuta, Raiz } from '@/componentes/ErrorDeRuta'
import { InicioPorRol, RutaProtegida } from '@/componentes/RutaProtegida'
import { ROLES_OFICINA } from '@/lib/permisos'
import { es } from '@/textos/es'

// Cada superficie es un chunk aparte: el celular de Muelle no descarga el tablero.
const Ops = lazy(() => import('@/superficies/ops'))
const Muelle = lazy(() => import('@/superficies/muelle'))
const Portal = lazy(() => import('@/superficies/portal'))
const Op = lazy(() => import('@/superficies/op'))
const Entrar = lazy(() => import('@/superficies/acceso/Entrar'))
const DefinirContrasena = lazy(() => import('@/superficies/acceso/DefinirContrasena'))
// Catálogo de componentes: solo en desarrollo, fuera del build de producción.
const PaginaSistema = import.meta.env.DEV
  ? lazy(() => import('@/superficies/ops/sistema/PaginaSistema'))
  : null

const conCarga = (el: React.ReactNode) => <Suspense fallback={<Cargando />}>{el}</Suspense>

function NoEncontrado() {
  return (
    <main className="p-8">
      <p>{es.comun.noEncontrado}</p>
      <Link to="/" className="underline">
        {es.comun.irAlInicio}
      </Link>
    </main>
  )
}

const hijas: RouteObject[] = [
  { path: '/', element: <InicioPorRol /> },
  { path: '/entrar', element: conCarga(<Entrar />) },
  { path: '/definir-contrasena', element: conCarga(<DefinirContrasena />) },
  {
    path: '/ops/*',
    element: <RutaProtegida roles={ROLES_OFICINA}>{conCarga(<Ops />)}</RutaProtegida>,
  },
  {
    path: '/muelle/*',
    element: <RutaProtegida roles={['muelle']}>{conCarga(<Muelle />)}</RutaProtegida>,
  },
  {
    path: '/portal/*',
    element: (
      <RutaProtegida roles={['cliente', 'despachador']}>{conCarga(<Portal />)}</RutaProtegida>
    ),
  },
  {
    path: '/op/*',
    element: <RutaProtegida roles={['operador']}>{conCarga(<Op />)}</RutaProtegida>,
  },
  ...(PaginaSistema ? [{ path: '/dev/sistema', element: conCarga(<PaginaSistema />) }] : []),
  { path: '*', element: <NoEncontrado /> },
]

// Una raíz con su errorElement envuelve a todas: si una pantalla no se pudo descargar (versión
// nueva publicada o sin servidor), recarga una vez y luego avisa en español (#64). Los errores
// de las rutas internas de cada superficie también suben hasta aquí.
export const rutas: RouteObject[] = [
  { element: <Raiz />, errorElement: <ErrorDeRuta />, children: hijas },
]
